import { ConsignadoProduct } from "@/models/consignado-product.model";

import {
  Button,
  useToast,
  useDisclosure,
  AlertDialog,
  AlertDialogOverlay,
  AlertDialogContent,
  AlertDialogHeader,
  AlertDialogBody,
  AlertDialogFooter,
} from "@chakra-ui/react";
import { useRef } from "react";
import { useNavigate } from "react-router-dom";

interface DeleteButtonProps {
  updateService: (id: any, data: Partial<ConsignadoProduct>) => Promise<ConsignadoProduct>;
  id: string | number; 
  navigateRoute: string;
  entityName: string; 
  entityIdentifier?: string; 
  buttonProps?: any; 
}

export default function DeleteButton({
  updateService,
  id,
  navigateRoute,
  entityName,
  entityIdentifier = "",
  buttonProps,
}: DeleteButtonProps) {
  const toast = useToast();
  const navigate = useNavigate();
  const { isOpen, onOpen, onClose } = useDisclosure();
  const cancelRef = useRef<HTMLButtonElement>(null);

  const handleDelete = async () => {
    try {
      await updateService(id, { habilitado: false });
      toast({
        title: `${entityName} desativado`,
        description: `${entityName} ${entityIdentifier} foi desativado com sucesso!`,
        status: "success",
        duration: 3000,
        isClosable: true,
      });
      navigate(navigateRoute);
    } catch (error: any) {
      toast({
        title: `Erro ao desativar ${entityName}`,
        description: error.message,
        status: "error",
        duration: 3000,
        isClosable: true,
      });
    }
    onClose(); 
  };

  return (
    <>
      <Button
        colorScheme="red"
        variant="outline"
        onClick={onOpen}
        {...buttonProps}
      >
        Desativar {entityName}
      </Button>

      <AlertDialog
        isOpen={isOpen}
        leastDestructiveRef={cancelRef} 
        onClose={onClose}
        isCentered 
      >
        <AlertDialogOverlay>
          <AlertDialogContent>
            <AlertDialogHeader fontSize="lg" fontWeight="bold">
              Desativar {entityName}
            </AlertDialogHeader>

            <AlertDialogBody>
              Tem certeza que deseja desativar {entityName} {entityIdentifier}?
              Essa ação não pode ser desfeita.
            </AlertDialogBody>

            <AlertDialogFooter>
              <Button ref={cancelRef} onClick={onClose}>
                Cancelar
              </Button>
              <Button colorScheme="red" onClick={handleDelete} ml={3}>
                Confirmar
              </Button>
            </AlertDialogFooter>
          </AlertDialogContent>
        </AlertDialogOverlay>
      </AlertDialog>
    </>
  );
}